import RMATableView from "./RMATableView";
import {useTranslation} from "react-i18next";
import CardView from "./CardView";

export default function RMAListView() {
    const {t} = useTranslation();
    return <CardView title={t('Request Details')} headerIcon={null}>
        <RMATableView/>
    </CardView>;
}